module.exports = __webpack_public_path__ + "img/icon_文件列表_file@3x.7ddd8297.png";